/*
 * Marketplace specific configuration.
 */

import insuranceLogo from '../src/assets/insuranceLogo.svg';

export const mailContact = 'hello@swimmy.fr';

export const pressMail = 'ciao@swimmy.com';
export const pressPhoneNumber = '+33781778394';
export const pressPhoneNumberReadable = '+33 7 81 77 83 94';

export const supportPhoneNumber = '+33186476130';
export const supportPhoneNumberReadable = '+33 1 86 47 61 30';

export const hasInsurance = true;
export { insuranceLogo };

export const hasSecurityLaw = false;
export const securityRulesURL = 'https://www.swimmy.fr/security-rules';
export const securityOptions = [
  { key: 'barriereDeProtection', label: 'Barriera di protezione' },
  { key: 'bacheDeSecurite', label: 'Telone di sicurezza' },
  { key: 'abriDePiscine', label: 'Copertura per piscina' },
  { key: 'alarmeDeSecurite', label: 'Allarme di sicurezza' },
];

// this is used to toggle reviews on LandingPage/SimulatorPage
export const showReviews = false;

export const showPressArticles = true;

export const eventQuery = '?address=Italy&bounds=47.09199997988367%2C18.79759992139748%2C35.48969995195065%2C6.626720064926066&origin=41.87194%2C12.56738&country=IT';

export const amenities = [
  { key: 'piscine_interieure', label: '🏊 Piscine interna' },
  { key: 'piscine_chauffee', label: '🌡️ Piscina riscaldata' },
  { key: 'douche', label: '🚿 Doccia' },
  { key: 'toilette', label: '🚽 Bagni' },
  { key: 'jacuzzi', label: '🛁 Jacuzzi' },
  { key: 'sauna', label: '🧖 Sauna' },
  { key: 'jardin', label: '☀️ Giardino' },
  { key: 'transats', label: '⛱️ Lettini' },
  { key: 'table_et_chaises', label: '🪑 Tavoli e sedie' },
  { key: 'bbq', label: '🍖 Barbecue' },
  { key: 'bouées', label: '🤽 Salvagenti' },
  { key: 'jeux', label: '🥏 Area di giochi esterni' },
  { key: 'tennis', label: '🎾 Campo di tennis' },
  { key: 'petanque', label: '🎯 Campo di bocce' },
  { key: 'wifi', label: '💻 Wi-Fi' },
];

export const validExtras = [
  'barbecueFee',
  'towelsFee',
  'jacuzziFee',
  'snackFee',
];

export const paidExtras = [
  {
    data: {
      amount: 1000, currency: 'EUR', id: 'barbecueFee', isByUnit: false,
      information: 'Puoi proporre il tuo barbecue per 10€ a noleggio. T’impegni a fornire il carburante al locatario.',
    },
    key: 'barbecueFee',
    label: '🍖 Barbecue • 10€',
  },
  {
    data: {
      amount: 300, currency: 'EUR', id: 'towelsFee', isByUnit: true,
      information: 'Puoi offrire asciugamani per 3€ al pezzo.',
    },
    key: 'towelsFee',
    label: '🧺 Asciugamani • 3€/persona',
  },
  {
    data: { amount: 1000, currency: 'EUR', id: 'jacuzziFee', isByUnit: true },
    key: 'jacuzziFee',
    label: '🛁 Spa / Idromassaggio • 10€/persona',
  },
  {
    data: {
      amount: 400, currency: 'EUR', id: 'snackFee', isByUnit: true,
      information: 'Puoi proporre uno spuntino per 4€/persona. Puoi aggiungere una descrizione nel tuo annuncio.',
    },
    key: 'snackFee',
    label: '🥤 Spuntino • 4€/persona',
  },
];

export const providerPresentOptions = [
  { key: 'oui', label: 'Sì' },
  { key: 'non', label: 'No' },
  { key: 'occasionnellement', label: 'Occasionalmente' },
];

export const howDidYouKnowUsOptions = [
  { key: 'wordOfMouth', label: 'Passaparola' },
  { key: 'medias', label: 'Media' },
  { key: 'bySwimmyTeamContact', label: 'Sono stato contattato dal Team Swimmy' },
  { key: 'byFacebook', label: 'Facebook' },
  { key: 'instagram', label: 'Instagram' },
  { key: 'byAds', label: 'Ho visto una pubblicità su Internet' },
  { key: 'bySwimmyBlog', label: 'Il Blog Swimmy' },
];

/**
 * Customer commission percentage which is added
 * to the total price of every booking.
 */
export const customerCommissionPercentage = 20;

/**
 * Discount multiplier for children.
 */
export const childrenDiscountMultiplier = 0.5;

/**
 * Custom multipliers to be used with bounds expansion
 * to run location searches on larger areas.
 *
 * The key musy match the address value of a place
 * returned by the Google Maps API.
 */
export const customBoundsMultiplier = {
  'Paris, France': 4.5,
};

export const filters = [
  {
    id: 'price',
    label: 'Prezzo',
    type: 'PriceFilter',
    group: 'secondary',
    // Note: PriceFilter is fixed filter,
    // you can't change "queryParamNames: ['price'],"
    queryParamNames: ['price'],
    // Price filter configuration
    // Note: unlike most prices this is not handled in subunits
    config: {
      min: 1,
      max: 500,
      step: 1,
    },
  },
  {
    id: 'amenities',
    label: 'Attrezzature',
    type: 'SelectMultipleFilter',
    group: 'primary',
    queryParamNames: ['pub_extras'],
    config: {
      // Optional modes: 'has_all', 'has_any'
      // https://www.sharetribe.com/api-reference/marketplace.html#extended-data-filtering
      searchMode: 'has_all',

      // "key" is the option you see in Flex Console.
      // "label" is set here for this web app's UI only.
      // Note: label is not added through the translation files
      // to make filter customizations a bit easier.
      options: amenities,
    },
  },
  {
    id: 'capacity',
    label: 'Filter.capacityLabel',
    type: 'CapacityFilter',
    group: 'primary',
    queryParamNames: ['pub_maxCapacityToGuest', 'pub_minCapacityToGuest', 'adults', 'children', 'infants', 'pub_enfantsBienvenue'],
    config: {
      min: 0,
      helper: 'Filter.capacityHelper'
    },
  },
  {
    id: 'superHost',
    label: 'Filter.superHostLabel',
    type: 'BooleanFilter',
    group: 'secondary',
    queryParamNames: ['pub_isHostedBySuperHost'],
    config: {
      helper: 'Filter.superHostHelper',
    },
  },
  {
    id: 'policyEvent',
    label: 'Filter.policyEventLabel',
    type: 'BooleanFilter',
    group: 'secondary',
    queryParamNames: ['pub_policyEvent'],
    config: {
      helper: 'Filter.policyEventHelper',
    },
  },
  {
    id: 'policyMusic',
    label: 'Filter.policyMusicLabel',
    type: 'BooleanFilter',
    group: 'secondary',
    queryParamNames: ['pub_policyMusic'],
    config: {
      helper: 'Filter.policyMusicHelper',
    },
  },
  {
    id: 'policyPets',
    label: 'Filter.policyPetsLabel',
    type: 'BooleanFilter',
    group: 'secondary',
    queryParamNames: ['pub_policyPets'],
    config: {
      helper: 'Filter.policyPetsHelper',
    },
  },
];

export const sortConfig = {
  // Enable/disable the sorting control in the SearchPage
  active: false,

  // Note: queryParamName 'sort' is fixed,
  // you can't change it since Flex API expects it to be named as 'sort'
  queryParamName: 'sort',

  // Internal key for the relevance option, see notes below.
  relevanceKey: 'relevance',

  // Keyword filter is sorting the results already by relevance.
  // If keyword filter is active, we need to disable sorting.
  conflictingFilters: ['keyword'],

  options: [
    { key: 'createdAt', label: 'Newest' },
    { key: '-createdAt', label: 'Oldest' },
    { key: '-price', label: 'Lowest price' },
    { key: 'price', label: 'Highest price' },

    // The relevance is only used for keyword search, but the
    // parameter isn't sent to the Marketplace API. The key is purely
    // for handling the internal state of the sorting dropdown.
    { key: 'relevance', label: 'Relevance', longLabel: 'Relevance (Keyword search)' },
  ],
};

// 'km' for kilometers or 'mi' for miles
export const distanceUnit = 'km';
/**
 * If isSeasonalMarketplace is true both seasonStart and
 * seasonEnd must have a value
 *
 * Months have to be set using those values :
 * January = 0
 * ...
 * December = 11
 */

export const isSeasonalMarketplace = false;
export const seasonStart = {
  month: 'Maggio',
  value: 4,
};
export const seasonEnd = {
  month: 'October',
  value: 9,
};

// By default the age requirement is 18
export const marketplaceAgeRequirement = 18;

// key is for average cost in the labeled region
export const simulatorFormLocations = [
  { key: 2300, label: `Lombardia` },
  { key: 3600, label: 'Liguria' },
  { key: 1900, label: 'Sardegna' },
  { key: 2200, label: 'Friuli Venezia Giulia' },
  { key: 1700, label: 'Puglia' },
  { key: 2600, label: 'Piemonte' },
  { key: 2600, label: 'Lazio' },
  { key: 2000, label: 'Emilia-Romagna' },
  { key: 1900, label: 'Calabria' },
  { key: 1800, label: 'Sicilia' },
  { key: 1600, label: 'Campania' },
  { key: 1800, label: 'Altre regioni' },
];

export const withEveningBookingModeDate = '2021-04-13T15:30:00.000Z';

export const insuranceSlug = 'roots?slug=insurance-it';

export const termsOfUseSlug = 'roots?slug=terms-of-use-it';

export const legalNoticeSlug = 'roots?slug=legal-notice-it';

export const helpCenterUrl = 'https://help.swimmy.com/hc/it';
export const helpCenterUrlForCustomers = 'https://help.swimmy.com/hc/it/categories/360002484820-Sono-un-inquilino';
export const helpCenterUrlForProviders = 'https://help.swimmy.com/hc/it/categories/360002499219-Sono-un-proprietario';

export const country = 'it';

export const supportHours = {
  start: '9:00',
  end: '18:00',
};

export const stripeIdentityDocuments = [
  'Passaporto',
  'Patente di guida - fronte e retro',
  'Carta d\'identità - fronte e retro',
];

export const stripeAddressDocuments = [
  'Fattura telefonica - datata meno di 6 mesi',
  'Fattura dell\'elettricità, del gas o dell\'acqua - datata meno di 6 mesi',
  'Certificato o fattura di assicurazione abitativa - con data inferiore a 6 mesi',
  'Titolo della proprietà',
];




// WEBPACK FOOTER //
// ./src/marketplace-custom-config.js